import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { FHButton } from '../../../components/base';
import { history } from '../../../helpers';
import { EVV_TOKEN_KINDS } from '../constants';
import { formatSessionNoteId } from '../utils';
import { useEvvGpsCapture } from './hooks';
import {
  EVV_PAGE_AVATAR_SX,
  EVV_PAGE_BODY_SX,
  EVV_PAGE_CONTENT_SX,
  EVV_PAGE_DONE_BODY_SX,
  EVV_PAGE_ERROR_SX,
  EVV_PAGE_HEADER_META_SX,
  EVV_PAGE_HEADER_SX,
  EVV_PAGE_HEADER_TITLE_SX,
  EVV_PAGE_HEADING_SX,
  EVV_PAGE_ROOT_SX,
  EVV_PAGE_SESSION_ID_SX,
  EVV_PAGE_SHELL_SX,
  EVV_PAGE_VERIFY_BUTTON_SX,
} from './styles';

function EvvVerification() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const sessionId = searchParams.get('sessionId');
  const shouldReturnToSession = searchParams.get('returnToSession') === 'true';
  const kind =
    searchParams.get('kind') === EVV_TOKEN_KINDS.END
      ? EVV_TOKEN_KINDS.END
      : EVV_TOKEN_KINDS.START;
  const { captureStatus, errorMessage, captureGps } = useEvvGpsCapture({
    token,
    onCaptured: () => {
      if (shouldReturnToSession && sessionId) {
        history.navigate(`/sessions/${sessionId}`);
      }
    },
  });
  const isDone = captureStatus === 'done';
  const isEnd = kind === EVV_TOKEN_KINDS.END;

  return (
    <Box sx={EVV_PAGE_ROOT_SX}>
      <Box sx={EVV_PAGE_SHELL_SX}>
        <Box sx={EVV_PAGE_HEADER_SX}>
          <Typography sx={EVV_PAGE_HEADER_TITLE_SX}>EVV Verification</Typography>
          <Box sx={EVV_PAGE_HEADER_META_SX}>
            <Typography sx={EVV_PAGE_SESSION_ID_SX}>
              Session ID: {formatSessionNoteId(sessionId)}
            </Typography>
            <Box sx={EVV_PAGE_AVATAR_SX}>BT</Box>
          </Box>
        </Box>
        <Box sx={EVV_PAGE_CONTENT_SX}>
          <Typography component="h1" sx={EVV_PAGE_HEADING_SX}>
            {isDone ? 'Done' : `Verify session ${isEnd ? 'end' : 'start'}`}
          </Typography>
          <Typography sx={isDone ? EVV_PAGE_DONE_BODY_SX : EVV_PAGE_BODY_SX}>
            {isDone
              ? 'Please return to your session note.'
              : `Click the verify button below to verify and you can return to your computer to ${
                  isEnd ? 'conclude' : 'continue'
                } the session notes.`}
          </Typography>
          {errorMessage && <Typography sx={EVV_PAGE_ERROR_SX}>{errorMessage}</Typography>}
          {!isDone && (
            <FHButton
              data-testid="evvVerifyButton"
              loading={captureStatus === 'capturing'}
              disabled={captureStatus === 'capturing'}
              sx={EVV_PAGE_VERIFY_BUTTON_SX}
              onClick={captureGps}
            >
              Verify
            </FHButton>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default EvvVerification;
